module.exports = __webpack_public_path__ + "static/media/javine.c3eecf00.jpg";